.shortcutMenu {
  align-items: center;
  display: flex;
  flex: 0 0 var(--shortcut-menu-width, 65px);
  column-gap: 4px;
  justify-content: space-between;
  width: var(--shortcut-menu-width, 65px);
  visibility: var(--shortcut-menu-visibility);
  opacity: var(--shortcut-menu-multiplier);
  transition-duration: 50ms;
  transition-timing-function: ease-out;
  transition-property: visibility, opacity;
}
.shortcutMenu.incoming {
  flex-direction: row;
  margin-inline-start: 10px;
}
.shortcutMenu.outgoing {
  flex-direction: row-reverse;
  margin-inline-end: 10px;
}

.shortcutMenuButton {
  opacity: 0.6;
  background-color: var(--chatViewBg);
  border: 0;
  border-radius: 50%;
  cursor: pointer;
  margin: 0;
  padding: 5px;
}

.shortcutMenuIcon {
  background-color: var(--contextMenuText);
  display: block;
  height: 20px;
  width: 20px;
}

.originalMessageButton {
  background-color: var(--showInChatButtonBg);
  border-radius: 100%;
  height: 40px;
  width: 40px;
  border: none;
  position: relative;
  padding: 0;
  cursor: pointer;
}

.originalMessageIcon {
  mask-image: url(./images/icons/chevron-right.svg);
  -webkit-mask: url(./images/icons/chevron-right.svg) no-repeat center;
  mask-size: 100%;
  -webkit-mask-size: 100%;
  width: 40px;
  height: 40px;
  background-color: var(--buttonPrimaryText);
  margin-inline-start: 2px;
}